module.exports = __webpack_public_path__ + "media/icons/heart-filled-388f879f.svg";